import { Header, Footer, PageHero, ServicesBlock, WhyUsBlock, EstimateForm } from "@/components/site";

export default function ServicesPage() {
  return (
    <div className="bg-white text-slate-800">
      <Header />
      <PageHero overline="What We Do" title="Our Painting Services" subtitle="Interior, exterior, ceilings, trim, drywall repairs, deck & fence staining, and commercial painting — done right, on time." />
      <ServicesBlock />
      <WhyUsBlock />
      <EstimateForm />
      <Footer />
    </div>
  );
}
